var map = {
	"./romme_logo.png": 6544,
	"./romme_logo_de.png": 7676,
	"./romme_logo_fr.png": 375,
	"./romme_logo_glow.png": 4884,
	"./romme_logo_nl.png": 6832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9676;